<script lang="ts">
    import { onMount } from "svelte";
    import Employee from "../Models/Employee";
    import Card from "../Components/Card/Card.svelte";
    import Session from "../Models/Session";
    import { Dialog, Modal } from 'attractions';
    import ProductsAutocomplete from "../Components/ProductsAutocomplete/ProductsAutocomplete.svelte";
    import PurchasePrice from "../Components/PurchaseSummary/PurchasePrice.svelte";
    import PurchaseSend from "../Components/PurchaseSummary/PurchaseSend.svelte";
    import { LATEST_PURCHASE } from "../Stores/Purchase";
    import EmployeesModal from "../Components/AddEmployee/EmployeesModal.svelte";
    import PurchaseSuccessModal from "../Components/PurchaseSummary/PurchaseSuccessModal.svelte";
    import PurchaseHistoryModal from "../Components/PurchaseHistory/PurchaseHistoryModal.svelte";
    import SelectEmployeeWithReportModal from "../Components/EmployeePurchasesActions/EmployeesPurchasesActionsModal.svelte";
    import { EMPLOYEE_DETAILS, EMPLOYEE_ROLES } from "../Stores/Session";
    import GroupOfSimilar from "../Components/Dashboard/GroupOfSimilar.svelte";
    import ProductsBaseModal from "../Components/ProductsBase/ProductsBaseModal.svelte";

    let addPurchaseMode: boolean = false;
    let addEmployeeMode: boolean = false;
    let functionalityFilters: string[] = [];
    let productsBaseMode: boolean = false;
    let purchaseAddedMode: boolean = false;
    let purchasesHistoryMode: boolean = false;
    let role: any;
    let selectEmmployeeWithPurchasesReportMode: boolean = false;
    let employeeDetails;

    onMount(async () => {
        const sessionToken = Session.getToken();
        const details = await Employee.getDetails();
        employeeDetails = details;
        role = details.role;
        EMPLOYEE_DETAILS.set(details);
        EMPLOYEE_ROLES.set(details.role);
        if (!sessionToken) window.location.replace('/#/auth');
    })

    function shouldSectionBeVisible(sectionName: string) {
        return functionalityFilters.length == 0 || functionalityFilters.includes(sectionName);
    }

    function toggleAddEmployeeMode() {
        addEmployeeMode = !addEmployeeMode;
    }

    function togglePurchaseMode() {
        addPurchaseMode = !addPurchaseMode;
    }

    function toggleHistoryMode() {
        purchasesHistoryMode = !purchasesHistoryMode;
    }

    function toggleSelectEmployeeWithReportMode() {
        selectEmmployeeWithPurchasesReportMode = !selectEmmployeeWithPurchasesReportMode;
    }

    function toggleProductsBaseMode() {
        productsBaseMode = !productsBaseMode;
    }

    LATEST_PURCHASE.subscribe(data => {
        if (data) {
            addPurchaseMode = false;
            purchaseAddedMode = true;
        }
    });
</script>

{#if employeeDetails}
    <section class="dashboard">
        <section class="menu">
            {#if shouldSectionBeVisible("Zakupy i raporty")}
                <GroupOfSimilar title="Zakupy i raporty">
                    {#if role.addPurchase}
                        <Card on:click={togglePurchaseMode} blured pointer zoomable imagePath="/assets/chair_min.jpg">
                            Dodaj zakup
                        </Card>
                    {/if}
                    {#if role.getPurchasesHistory}
                        <Card on:click={toggleHistoryMode} blured pointer zoomable imagePath="/assets/debit_card_min.jpg">
                            Twoja historia zakupów
                        </Card>
                    {/if}
                    {#if role.getEmployeesPurchases}
                        <Card on:click={toggleSelectEmployeeWithReportMode} blured pointer zoomable imagePath="/assets/table_min.jpg">
                            Raporty zakupów
                        </Card>
                    {/if}
                </GroupOfSimilar>
            {/if}
            {#if shouldSectionBeVisible("Pracownicy")}
                <GroupOfSimilar title="Pracownicy">
                    {#if role.addEmployee}
                        <Card on:click={toggleAddEmployeeMode} blured pointer zoomable imagePath="/assets/employee_min.jpg">
                            Pracownicy
                        </Card>
                    {/if}
                </GroupOfSimilar>
            {/if}
            {#if shouldSectionBeVisible("Produkty")}
                <GroupOfSimilar title="Produkty">
                    {#if role.addEmployee}
                        <Card on:click={toggleProductsBaseMode} blured pointer zoomable imagePath="/assets/products_min.jpg">
                            Baza produktów
                        </Card>
                    {/if}
                </GroupOfSimilar>
            {/if}
        </section>

        {#if role.addPurchase}
            <Modal bind:open={addPurchaseMode} let:closeCallback>
                <Dialog title="Nowy zakup" {closeCallback}>
                    <ProductsAutocomplete />
                    <PurchasePrice />
                    <PurchaseSend />
                </Dialog>
            </Modal>
        {/if}
        
        {#if role.getPurchasesHistory}
            <PurchaseHistoryModal bind:open={purchasesHistoryMode} />
        {/if}
        
        {#if role.addPurchase}
            <PurchaseSuccessModal bind:open={purchaseAddedMode} />
        {/if}

        {#if role.getEmployeesList || role.addEmployee}
            <EmployeesModal bind:open={addEmployeeMode} />
        {/if}

        {#if role.getEmployeesPurchases}
            <SelectEmployeeWithReportModal bind:open={selectEmmployeeWithPurchasesReportMode} />
        {/if}

        {#if role.addProduct || role.editProduct}
            <ProductsBaseModal bind:open={productsBaseMode} />
        {/if}
    </section>
{/if}

<style type="text/scss">
    .dashboard {
        background-color: #f45b69;
		display: flex;
		flex-direction: column;
        flex-flow: wrap;
		justify-content: center;
		align-items: center;
		min-height: 100vh;

        .menu {
            display: flex;
            flex-flow: wrap;

            @media (max-width: 768px) {
                margin-top: 6rem;
                flex-direction: column;
            }
        }
    }
</style>